import { otmsHttp, bfsUserWebHttp } from '@/utils/http/index.js'

/**
 * 站点列表
 * https://yapi.ops.yunlizhi.cn/project/130/interface/api/16507
 */
export function getStationList(data, params) {
  return otmsHttp.post('/base_plus/station/es/page', data, { params })
}

/**
 * 查询服务商
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/8432
 */
export function getTenantList(data) {
  return bfsUserWebHttp.post('/crm-plus/customer/special/list', data)
}

/**
 * POI列表
 * https://yapi.ops.yunlizhi.cn/project/130/interface/api/8552
 */
export function getPoiList(data) {
  return bfsUserWebHttp.post('/base_plus/poi/list', data)
}

/**
 * 创建站点
 * https://yapi.ops.yunlizhi.cn/project/130/interface/api/10818
 */
export function createStation(data) {
  return bfsUserWebHttp.post('/base_plus/station/create/v2', data)
}

/**
 * 站点详情
 * https://yapi.ops.yunlizhi.cn/project/130/interface/api/6185
 */
export function getStationDetail(data) {
  return otmsHttp.post('/base_plus/station/detail', data)
}

/**
 * 更新站点
 * https://yapi.ops.yunlizhi.cn/project/130/interface/api/10820
 */
export function updateStation(data) {
  return otmsHttp.post('/base_plus/station/update', data)
}

/**
 * 删除站点
 * https://yapi.ops.yunlizhi.cn/project/130/interface/api/10828
 */
export function deleteStation(data) {
  return otmsHttp.post('/base_plus/station/delete', data)
}
// 站点变更日志 
export function stationChangeLog(data, page, size) {
  return otmsHttp.post(`/base_plus/station/change_log/detail/page?page=${page}&size=${size}`, data)
}

/**
 * 根据货主查询主体
 * https://yapi.ops.yunlizhi.cn/project/295/interface/api/36226
 */
export function mainManagerListByCustomer(data) {
  return otmsHttp.post('/crm-plus/main/manager/list/by_customer', data)
}

/**
 * 
 * https://yapi.ops.yunlizhi.cn/project/295/interface/api/36226
 */
export function createImport(data) {
  return otmsHttp.post('/bfs_exporter/task/create_import', data)
}
export function createExport(data) {
  return otmsHttp.post('/bfs_exporter/task/create_export', data)
}
